export default __webpack_public_path__ + "static/media/fasad5.45fdea48.jpeg";